import { useMemo } from 'react'
import { useTable } from 'react-table'
import {
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
} from './core/QueryResponseProvider'
import { fields } from './core/_models'
import { QUERIES } from '../../../../../_metronic/helpers'
import { useListView } from './core/ListViewProvider'
import { useQueryRequest } from './core/QueryRequestProvider'
import { deleteJob, updateJob } from './core/_requests'
import { cells } from '../../../../../_component/table/Cell'
import { KTable } from '../../../../../_component/table/Table'
import { UserPlus } from 'lucide-react'

type Props = {
  openApplyModal: (id: string) => void
}

export const Table = ({openApplyModal}: Props) => {
  const pagination = useQueryResponsePagination()
  const { state, updateState } = useQueryRequest()
  const { refetch } = useQueryResponse()
  const { setItemIdToView, setItemIdForUpdate, isAllSelected, onSelectAll, selected, onSelect } =
    useListView()
  const jobs = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => jobs, [jobs])
  const columns = useMemo(
    () => {
      const baseColumns = cells({
        model: QUERIES.JOB_LIST,
        fields: fields.filter((field) => field.table),
        state,
        updateState,
        updateAction: updateJob,
        deleteAction: deleteJob,
        setItemIdToView,
        setItemIdForUpdate,
        refetch,
        isAllSelected,
        onSelectAll,
        selected,
        onSelect,
        selectAble: true,
        actionAble: true,
        editUrl: '/jobs/edit/:id',
      })

      // Add Apply column before the last column (Actions)
      const applyColumn = {
        Header: (props: any) => (
          <th {...props.tableProps} className='text-center'>
            Apply
          </th>
        ),
        id: 'apply',
        Cell: ({...props}: any) => (
          <div className='text-center'>
            <button
              className='btn btn-sm btn-light-success btn-icon-success flex items-center gap-2 font-bold'
              onClick={() => openApplyModal(props.data[props.row.index].id)}
            >
              <UserPlus size={16} />
              <span className='hidden xl:inline'>Apply</span>
            </button>
          </div>
        ),
      }

      baseColumns.splice(baseColumns.length - 1, 0, applyColumn)
      return baseColumns
    },
    // eslint-disable-next-line
    [state, onSelectAll, openApplyModal]
  )
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })

  return (
    <KTable
      headers={headers}
      rows={rows}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
      prepareRow={prepareRow}
      setItemIdToView={setItemIdToView}
      isLoading={isLoading}
      pagination={pagination}
      updateState={updateState}
    />
  )
}
